import * as config from "../config";
import {Align} from "../class/align";
import _ from "underscore";


export default class Character {
    constructor(scene, x) {
        this.scene = scene;
        this.character = scene.character = scene.physics.add.sprite(
            0,
            this.scene.background.y + this.scene.background.displayHeight / 2 - 135,
            'character');
        this.character.body.allowDrag = false;
        this.character.damage = config.other.character.damage;
        this.character.negativeEffects = {
            manager: {
                time: 0,
                value: 0
            }
        };
        this.character.positiveEffects = {
            coin: {
                time: 0,
                value: 0
            }
        };
        this.makeAnimations();
        Align.centerWidth(this.character);
        this.character.body.setSize(160, 255, true);
        this.character.body.setOffset(25, 15);
        Align.scaleToGameW(this.character, .1)
        this.character.isKick = false;
    }

    set gravity(gravity) {
        this.character.setGravityY(gravity)
    }

    setManagerEffect(manager) {
        let date = new Date();
        date.setMilliseconds(date.getMilliseconds() + config.manager.time);
        this.character.setTint(0xFF0000, 0xFF0000, 0xFF0000, 0xFF0000);
        this.character.negativeEffects.manager.time = date;
        this.character.negativeEffects.manager.value = config.manager.value;
        let index = _.findIndex(this.scene.modelManager.dbManager.items, (element, index) => {
            return element.id === manager.id;
        });
        this.scene.groupManager.remove(manager, true, true)
        this.scene.modelManager.dbManager.items.splice(index, 1)
    }

    setCoinEffect(coin) {
        let date = new Date();
        date.setMilliseconds(date.getMilliseconds() + config.projectile.coin.time);
        this.character.setTint(0xFFD700, 0xFFD700, 0xFFD700, 0xFFD700);
        this.character.positiveEffects.coin.time = date;
        this.character.positiveEffects.coin.value = config.projectile.coin.value;
        this.scene.modelCoin.remove(coin)
    }

    jump() {
        if (this.character.body.velocity.y === 0) {
            this.character.setVelocityY(-700)
        }
    }

    kick() {
        this.character.isKick = true;
        this.scene.modelBullet.createBullet();
        this.character.play('kick', true);
        this.character.on('animationcomplete', (animation) => {
            if (animation.key === 'kick') {
                this.character.isKick = false;
            }
        })
    }

    changeAnimation() {
        if (!this.character.isKick) {
            if ((this.scene.movementKeys.right.isDown
                && this.character.body.velocity.y === 0)
                || (this.scene.movementKeys.left.isDown
                    && this.character.body.velocity.y === 0)) {
                this.character.play('run', true);
            } else if (this.character.body.velocity.y < 0) {
                this.character.play('jump');
            } else {
                this.character.play('idle', true);
            }
        }
    }

    navigation() {
        if (this.scene.movementKeys.right.isDown) {
            this.character.flipX = false;
            this.character.setVelocityX(600)
        } else if (this.scene.movementKeys.right.isUp && this.scene.movementKeys.left.isUp) {
            this.character.setVelocityX(0)
        } else if (this.scene.movementKeys.left.isDown) {
            this.character.flipX = true;
            this.character.setVelocityX(-600)
        } else if (this.scene.movementKeys.left.isUp && this.scene.movementKeys.right.isUp) {
            this.character.setVelocityX(0)
        }
    }

    negativeEffectsUpdate() {
        let date = new Date()
        if (date >= this.character.negativeEffects.manager.time && date >= this.character.positiveEffects.coin.time) {
            this.character.clearTint();
            this.character.negativeEffects.manager.time = 0;
            this.character.negativeEffects.manager.time = 0;
            this.character.positiveEffects.coin.time = 0;
            this.character.positiveEffects.coin.value = 0;
        } else if (date < this.character.negativeEffects.manager.time && date >= this.character.positiveEffects.coin.time) {
            this.character.setTint(0xFF0000, 0xFF0000, 0xFF0000, 0xFF0000);
            this.character.positiveEffects.coin.time = 0;
            this.character.positiveEffects.coin.value = 0;
        } else if (date >= this.character.negativeEffects.manager.time && date < this.character.positiveEffects.coin.time) {
            this.character.setTint(0xFFD700, 0xFFD700, 0xFFD700, 0xFFD700);
            this.character.negativeEffects.manager.time = 0;
            this.character.negativeEffects.manager.time = 0;
        }
    }

    makeAnimations() {
        this.scene.anims.create({
            key: 'idle',
            frames: this.scene.anims.generateFrameNames('character', {
                start: 1,
                end: 17,
                zeroPad: 1,
                prefix: 'boy_idle_',
                suffix: '.png'
            }),
            frameRate: 15,
            repeat: -1
        });
        this.scene.anims.create({
            key: 'run',
            frames: this.scene.anims.generateFrameNames('character', {
                start: 1,
                end: 17,
                zeroPad: 1,
                prefix: 'boy_run_',
                suffix: '.png'
            }),
            frameRate: 15,
            repeat: -1
        });
        this.scene.anims.create({
            key: 'jump',
            frames: this.scene.anims.generateFrameNames('character', {
                start: 1,
                end: 29,
                zeroPad: 1,
                prefix: 'boy_jump_',
                suffix: '.png'
            }),
            frameRate: 15,
            repeat: 0
        });
        this.scene.anims.create({
            key: 'kick',
            frames: this.scene.anims.generateFrameNames('character', {
                start: 1,
                end: 16,
                zeroPad: 1,
                prefix: 'boy_punch_',
                suffix: '.png'
            }),
            frameRate: 15,
            repeat: 0
        });
    }
}
